import moment from "moment";
import { kpiBasedType } from "./constants";
import { getBenchmarkData } from "./filterKpisData";

export const addToolDetailsInForm = function(formData, toolDetails) {
  delete toolDetails.nextStep;
  delete toolDetails.isPrivacySettingsChanged;
  let toolDetailsKeys = Object.keys(toolDetails);
  // console.log(toolDetailsKeys);
  for (let key of toolDetailsKeys) {
    if (key === "location") {
      formData.append("location", JSON.stringify(toolDetails.location));
    }
    if (key === "image") {
      formData.append("image", toolDetails.image);
    } else if (key === "attachment") {
      formData.append("attachment", toolDetails.attachment);
    } else if (key === "selectedLocations") {
      if (toolDetails.selectedLocations.countries.length > 0) {
        console.log(toolDetails.selectedLocations);
        let countries = toolDetails.selectedLocations.countries;
        let locations = countries.map((country) => {
          let states = [];
          if (country.code === "US") {
            states = toolDetails.selectedLocations.states.map(
              (state) => state.name
            );
          }
          return { country: country.name, states: states };
        });
        console.log(locations, JSON.stringify(locations));
        formData.append("locations", JSON.stringify(locations));
        // formData.append('newLocation',JSON.stringify(toolDetails.selectedLocations));
      }
    } else if (key === "diversityFocus") {
      let toolFocus = toolDetails.diversityFocus.map((focus) => {
        if (focus.key && focus.type !== "diversityFocusTag") {
          return focus.key;
        } else if (focus.type === "diversityFocusTag") {
          formData.append("diversityFocusTags", toolDetails.diversityFocusTags);
        }
      });
      formData.append(key, [...toolFocus]);
    } else if (key == "invitedUsers") {
      formData.append(key, JSON.stringify(toolDetails.invitedUsers));
    } else if (key === "relevantFor") {
      let toolFocus = toolDetails.relevantFor.map((focus) => {
        if (focus.key && focus.type !== "relevantForTag") {
          return focus.key;
        } else if (focus.type === "relevantForTag") {
          formData.append("relevantForTags", toolDetails.relevantForTags);
        }
      });
      formData.append(key, [...toolFocus]);
    } else if (key === "subCategory") {
      if (toolDetails.subCategory && toolDetails.subCategory.subCategoryValue) {
        formData.append(key, toolDetails.subCategory.subCategoryValue);
      }
    } else if (key === "permission") {
      if (toolDetails.permission && toolDetails.permission !== "") {
        formData.append(key, toolDetails.permission);
      }
    } else if (key === "isSharedWithOrg") {
      formData.append(key, toolDetails.isSharedWithOrg);
    } else {
      if (
        toolDetails[key] &&
        toolDetails[key] !== "" &&
        toolDetails[key] !== null
      ) {
        formData.append(key, toolDetails[key]);
      }
    }
  }
  console.log(formData);
  return formData;
};

export const addChartDetails = (data, createChartData) => {
  let {
    kpiAgreegateData,
    kpiRecords,
    selectedBenchmarkData,
    startDate,
    endDate,
    permission,
    kpiType,
    useLatestDataAvailable,
    benchmarkLocation,
  } = data;
  kpiRecords = kpiRecords.filter((kpiRecord) => kpiRecord.selected);

  if (
    kpiAgreegateData &&
    kpiAgreegateData.length > 0 &&
    kpiType === kpiBasedType.empDataBased
  ) {
    let kpiData = kpiRecords.map((kpiRecord, kpiRecordIndex) => {
      console.log("Aaiiii",kpiRecord);
      // if(kpiRecord.selected) {
      let kpiId = kpiRecord.selectedKPI.id;
   
      let kpiCode = kpiRecord.selectedKPI.code;
      let diversityType = kpiRecord.gender ? kpiRecord.gender.id : null;
      let occupationId = kpiRecord.occupation ? kpiRecord.occupation.id : null;
      let seniorityId = kpiRecord.seniority ? kpiRecord.seniority.id : null;
      let ethnicityId = kpiRecord.ethnicity ? kpiRecord.ethnicity.id : null;
      let veteranId = kpiRecord.veteran ? kpiRecord.veteran.id : null;
      let sexualOrientationId = kpiRecord.sexualOrientation
        ? kpiRecord.sexualOrientation.id
        : null;
      let religionId = kpiRecord.religion ? kpiRecord.religion.id : null;
      let disabilityId = kpiRecord.disability ? kpiRecord.disability.id : null;

      //Refs objects for ids
      let occupation_ref = kpiRecord.occupation ? kpiRecord.occupation.refObject : null;
      let seniority_ref = kpiRecord.seniority ? kpiRecord.seniority.refObject : null;
      let ethnicity_ref = kpiRecord.ethnicity ? kpiRecord.ethnicity.refObject : null;
      let veteran_ref = kpiRecord.veteran ? kpiRecord.veteran.refObject : null;
      let sexualOrientation_ref = kpiRecord.sexualOrientation
        ? kpiRecord.sexualOrientation.refObject
        : null;
      let religion_ref = kpiRecord.religion ? kpiRecord.religion.refObject : null;
      let disability_ref = kpiRecord.disability ? kpiRecord.disability.refObject : null;
      let ageStart, ageEnd;
      

      if (kpiRecord.ageStart) {
        if (kpiRecord.ageStart.id) {
          ageStart = kpiRecord.ageStart.id;
        } else if (kpiRecord.ageStart) {
          ageStart = kpiRecord.ageStart;
        }
      }

      if (kpiRecord.ageEnd) {
        if (kpiRecord.ageEnd.id) {
          ageEnd = kpiRecord.ageEnd.id;
        } else if (kpiRecord.ageEnd) {
          ageEnd = kpiRecord.ageEnd;
        }
      }

      // console.log(ethnicityId)
      // let kpiScore = kpiAgreegateData.map(kpiAgreegate => {
      //     let kpiScores = [];
      //     if (kpiAgreegate[kpiCode]) {
      //         kpiScores = kpiAgreegate[kpiCode].map(kpiScore => {
      //             return { value: kpiScore.score, date: kpiScore.isoDate }
      //         })
      //     }
      //     if (kpiScores.length > 0)
      //         return [...kpiScores];
      // })

      let kpiScore = kpiAgreegateData.map((kpiAgreegate, kpiAgreegateIndex) => {
        let kpiScores = [];
        if (kpiRecordIndex === kpiAgreegateIndex && kpiAgreegate[kpiCode]) {
          kpiScores = kpiAgreegate[kpiCode].map((kpiScore) => {
            // console.log(kpiScore)
            if (
              kpiScore.data &&
              (kpiScore.data.totalEmployees || kpiScore.data.numeratorCount)
            ) {
              // console.log(kpiScore)
              return {
                value: kpiScore.score,
                date: kpiScore.isoDate,
                totalEmployees: kpiScore.data.totalEmployees,
                numeratorType: kpiScore.data.numeratorType,
                numeratorCount: kpiScore.data.numeratorCount,
                numeratorEthnicity: kpiScore.ethnicityType,
                avgTenure: kpiScore.avgTenure >= 0
                  ? kpiScore.avgTenure
                  : kpiScore.docs && kpiScore.docs.avgTenure >= 0
                  ? kpiScore.docs.avgTenure
                  : undefined,
              };
              // return {value: kpiScore.score, date: kpiScore.isoDate, data: kpiScore.data }
            } else {
              return { value: kpiScore.score, date: kpiScore.isoDate };
            }
            // return {value: kpiScore.score, date: kpiScore.isoDate}
          });
        }
        if (kpiScores.length > 0) {
          return [...kpiScores];
        }
      });

      kpiScore = kpiScore.filter((score) => score);
      let selectedKPIData = { kpiId: kpiId, score: kpiScore[0] };

      if(selectedKPIData.kpiId && kpiRecord.selectedKPI && kpiRecord.selectedKPI.refObject){
        selectedKPIData["kpi_ref"] = kpiRecord.selectedKPI.refObject
      }
      selectedKPIData["diversityType"] = diversityType;
      if (occupationId !== null) {
        selectedKPIData["occupationId"] = occupationId;
        selectedKPIData["occupation_ref"] = occupation_ref;
      }
      if (seniorityId !== null){ 
        selectedKPIData["seniorityId"] = seniorityId;
        selectedKPIData["seniority_ref"] = seniority_ref;
        }
      if (ethnicityId !== null) {
        selectedKPIData["ethnicityId"] = ethnicityId;
        selectedKPIData["ethnicity_ref"] = ethnicity_ref;
      }
      if (veteranId !== null) {
        selectedKPIData["veteranId"] = veteranId;
        selectedKPIData["veteran_ref"] = veteran_ref
      }
      if (sexualOrientationId !== null) {
        selectedKPIData["sexualOrientationId"] = sexualOrientationId;
        selectedKPIData["sexualOrientation_ref"] = sexualOrientation_ref
      }
      if (religionId !== null) {
        selectedKPIData["religionId"] = religionId;
        selectedKPIData["religion_ref"] = religion_ref
      }
      if (disabilityId !== null) {
        selectedKPIData["disabilityId"] = disabilityId;
        selectedKPIData["disability_ref"] = disability_ref
      }
      if (ageStart !== null) {
        selectedKPIData["ageStart"] = ageStart;
      }
      if (ageEnd !== null) {
        selectedKPIData["ageEnd"] = ageEnd;
      }
      if (kpiRecord.selectedLocation.state !== null) {
        let { id, name } = kpiRecord.selectedLocation.state;
        selectedKPIData["location"] = { key: id, values: [id, name] };
      } else {
        selectedKPIData["location"] = { key: "ALL" };
      }

      // console.log('slected --->', selectedKPIData)
      return selectedKPIData;
      // }
    });
    kpiData = kpiData.filter((kpi) => kpi);
    kpiData = kpiData.map((kpi) => {
      if (kpi.score) {
        return { ...kpi };
      } else {
        return { ...kpi, score: [] };
      }
    });
    createChartData["kpiData"] = kpiData;
  }

  if (
    kpiAgreegateData &&
    kpiAgreegateData.length > 0 &&
    kpiType === kpiBasedType.surveyBased
  ) {
    let surveyKpiData = kpiRecords.map((kpiRecord) => {
      if (kpiRecord.selected) {
        let kpiId = kpiRecord.selectedKPI.id;
        let kpiCode = kpiRecord.selectedKPI.code;
        let scores = [];
        scores = kpiAgreegateData.map((kpiAgreegate) => {
          let surveyScore = [];
          if (kpiAgreegate[kpiCode]) {
            surveyScore = kpiAgreegate[kpiCode].map((kpiScore) => {
              // kpiScore.kpiInputs = kpiScore.kpiInputs
              return {
                value: kpiScore.score,
                date: kpiScore.selectedDate,
                results: kpiScore.kpiInputs,
              };
            });
          }
          if (surveyScore.length > 0) return [...surveyScore];
        });
        // let kpiInputs = kpiAgreegateData.map(kpiAgreegate => {
        //     return kpiAgreegate[kpiCode].map(kpiScore => kpiScore.kpiInputs);
        // });
        //    let kpiInputs = kpiAgreegateData.map(kpiAgreegate => {
        //         let surveyScore = [];
        //         if(kpiAgreegate[kpiCode]){
        //         surveyScore = kpiAgreegate[kpiCode].map(kpiScore => {
        //            return kpiScore.kpiInputs;
        //         });
        //         }
        //         if(surveyScore.length>0)
        //           return surveyScore[0];
        //     });
        // if(kpiInputs && kpiInputs.length > 0) {
        //     kpiInputs = [].concat.apply([], kpiInputs[0]);
        //     kpiInputs = kpiInputs.filter(kpiInput => kpiInput);
        // } else {
        //     kpiInputs = [];
        // }
        scores = scores.filter((kpiScore) => kpiScore);
        let selectedKPIData = {
          kpiId: kpiId,
          diversityType: "FEMALE",
          score: scores[0],
        };
        // console.log('selectedKPIData',selectedKPIData);
        return selectedKPIData;
      }
    });
    surveyKpiData = surveyKpiData.filter((kpi) => kpi);
    surveyKpiData = surveyKpiData.map((surveyKpi) => {
      if (surveyKpi.score) {
        return { ...surveyKpi };
      } else {
        return { ...surveyKpi, score: [] };
      }
    });
    createChartData["kpiData"] = surveyKpiData;
  }

  if (
    selectedBenchmarkData &&
    selectedBenchmarkData !== null &&
    selectedBenchmarkData.length > 0 &&
    kpiAgreegateData.length === 1 &&
    kpiType === kpiBasedType.empDataBased
  ) {
    //   if(selectedBenchmarkData && selectedBenchmarkData!==null && selectedBenchmarkData.length>0 && kpiAgreegateData.length === 1 && benchmarkLocation && benchmarkLocation.state!==null) {
    // let benchmarkType = selectedBenchmark.key;
    // let benchmarkScores = [];
    let benchmarkData = getBenchmarkData(
      { selectedBenchmark: selectedBenchmarkData, kpiAgreegateData },
      true,
      { startDate, endDate, useLatestDataAvailable }
    );
    // benchmarkScores = selectedBenchmarkData.data[0].docs.map(benchmark => {
    //     return{date: benchmark.date, value: benchmark.score};
    // })
    // benchmarkScores = benchmarkScores.filter(score => {
    //     if(startDate!==null && endDate!==null && !useLatestDataAvailable) {
    //         return moment(score.date) > moment(startDate) && moment(score.date) < moment(endDate);
    //      } else if (startDate!==null && !useLatestDataAvailable) {
    //        return moment(score.date) > moment(startDate);
    //      }  else if (startDate!==null && useLatestDataAvailable) {
    //        return moment(score.date) > moment(startDate) && moment(score.date) < moment(new Date());
    //      } else {
    //        return true;
    //      }
    // })
    let location = {};
    let { country, state } = benchmarkLocation;
    if (benchmarkLocation && country !== null && state !== null) {
      if (state === "ALL") {
        location = { key: "ALL" };
      } else {
        location = { key: state.id, name: state.name };
      }
    } else {
      location = { key: "ALL" };
    }
    createChartData["benchmarkData"] = { location, score: benchmarkData.score };
  }
  if (startDate != null && startDate !== "") {
    createChartData["startDate"] = startDate;
  }
  //   if(endDate!=null && endDate!=="") {
  createChartData["endDate"] = endDate;
  //   }
  if (permission != null && permission !== "") {
    createChartData["permission"] = permission;
  }
  return createChartData;
};
